import { MenuItem } from '@headlessui/react';
import { Link } from 'react-router-dom';
import { ItemMenuListItemProps } from './types';

const ItemMenuListItem = ({
  label,
  name = label,
  to,
  onClick,
  disabled,
  as: Component = to ? Link : 'button',
}: ItemMenuListItemProps) => {
  return (
    <MenuItem>
      <Component
        {...(to ? { to } : {})}
        {...(onClick ? { onClick } : {})}
        variant="link"
        disabled={disabled}
        className="font-semibold block w-full px-3 py-1 text-sm/6 text-gray-900 data-[focus]:outline-none text-justify disabled:text-gray-400 disabled:cursor-not-allowed hover:text-primary focus:outline-none"
      >
        {label}
        <span className="sr-only">, {name}</span>
      </Component>
    </MenuItem>
  );
};

export default ItemMenuListItem;
